import { Controller, UseControllerProps } from "react-hook-form";
import { MultiValue, StylesConfig } from "react-select";

import CreatableSelect from "react-select/creatable";

import { ErrorForm } from "./ErrorForm.tsx";
import { LabelForm, LabelFormProps } from "./LabelForm.tsx";
import { SCvalues } from "../../../_helpers/commonComponentsTypes.ts";

const Styles: StylesConfig<SCvalues, true> = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "#FAFAFA",
    borderColor: "#C5C5C5",
  }),
  container: (styles) => ({
    ...styles,
    width: "100%",
    minHeight: "38px",
  }),
  option: (styles, { isDisabled }) => ({
    ...styles,
    backgroundColor: "#FAFAFA",
    color: "#000",
    cursor: isDisabled ? "not-allowed" : "default",
    ":hover": {
      ...styles[":active"],
      backgroundColor: "#641ABF",
      color: "#FFF",
    },
  }),
  menu: (styles) => ({
    ...styles,
    zIndex: 999999,
  }),
  multiValue: (styles) => {
    return {
      ...styles,
      backgroundColor: "#641ABF",
    };
  },
  multiValueLabel: (styles) => ({
    ...styles,
    color: "#FFF",
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    color: "#FFF",
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#6c757d",
  }),
};

export const arrayValueToString = (values: MultiValue<any>) => {
  return values ? values.map((v) => v.value).join(",") : "";
};

export const stringToArrayValue = (value?: string): MultiValue<any> => {
  return value ? value.split(",").map((v) => ({ value: v, label: v })) : [];
};

type SelectCreatableFormProps = {
  options: Array<{ label: string; value: string }>;
  isMulti?: boolean;
  creatable?: boolean;
  placeholder?: string;
} & UseControllerProps &
  LabelFormProps;
const SelectCreatableForm = (props: SelectCreatableFormProps) => {
  const noOptionsMessage = () => "Pas de résultats";

  return (
    <div className="form-input">
      <LabelForm
        label={props.label}
        required={!!props.rules?.required}
        labelInfos={props.labelInfos}
      />
      <Controller
        control={props.control}
        name={props.name}
        defaultValue={props.defaultValue}
        render={({ field, fieldState }) => {
          return (
            <div className={"d-flex flex-column"}>
              <div
                className={
                  "d-flex justify-content-center align-items-center w-100 loader-height"
                }
              >
                <CreatableSelect
                  styles={Styles}
                  formatCreateLabel={(inputValue) => `Créer "${inputValue}"`}
                  onChange={(value) => {
                    field.onChange(arrayValueToString(value));
                  }}
                  noOptionsMessage={noOptionsMessage}
                  options={props.options}
                  isMulti={props.isMulti ? true : undefined}
                  placeholder={props.placeholder ?? " "}
                  defaultValue={stringToArrayValue(
                    field.value ?? props.defaultValue,
                  )}
                  value={stringToArrayValue(field.value)}
                />
              </div>
              <ErrorForm error={fieldState.error} />
            </div>
          );
        }}
        rules={props.rules}
      />
    </div>
  );
};

export default SelectCreatableForm;
